<template>
  <div>
    <div class="loading" v-if="loading">
      <div class="loader">
        <span></span>
        <span></span>
        <span></span>
        <span></span>
        <span></span>
        <span></span>
        <span></span>
        <span></span>
        <span></span>
        <span></span>
        <span></span>
        <span></span>
        <span></span>
        <span></span>
        <span></span>
      </div>
    </div>
    <div v-if="fetch">
      <div
        class=""
        style="background-size: cover; background-position: center left"
      >
        <nav class="navbar" style="background-color: rgba()">
          <router-link class="navbar-brand" to="/">
            <img src='../../../static/img/logo/Logo2.jpeg' width="50" height="50" alt="eshops-logo" />
          </router-link>
          <div>
            <router-link to="/" class="text-info mr-1 m-link">Home</router-link>
            <!-- <router-link
              :to="{ name: 'regshop', params: { plan: 'Premium' } }"
              class="text-info m-link"
              >Create Store</router-link
            > -->
          </div>
        </nav>
        <div style="background-color: rgba(0, 0, 0, 0); height: 100%" class="">
          <div class="col-sm-8 col-md-4 m-auto pb-5">
            <h2 class="m-auto text-center pt-5 pb-2" style="color: #e94de9">
              User Sign Up
            </h2>
            <el-form
              :model="formdata"
              status-icon
              :rules="rules2"
              ref="formdata"
              label-width="120px"
              :label-position="labelPosition"
              size="medium"
              style="
                border: 1px solid #e2e2e2;
                border-radius: 5px;
                background-color: #fff;
                padding: 20px;
              "
            >
              <el-form-item
                label="Name"
                prop="name"
                :rules="[
                  {
                    required: true,
                    message: 'Please input your name',
                    trigger: 'blur',
                  },
                ]"
              >
                <el-input placeholder="Name" v-model="formdata.name"></el-input>
              </el-form-item>
              <!-- <el-checkbox v-model="checked"  style="visibility: hidden;" @change="submit(checked)"> 
      <i class="fa fa-heart" style="visibility: visible;"></i>
    </el-checkbox> -->
              <el-form-item
                label="Telephone"
                prop="telephone"
                :rules="[
                  { required: true, message: 'telephone no is required' },
                  { type: 'number', message: 'telephone no must be a number' },
                ]"
              >
                <el-input
                  placeholder="777666666 (without 0)"
                  v-model.number="formdata.telephone"
                  auto-complete="off"
                ></el-input>
              </el-form-item>
              <el-form-item
                prop="email"
                label="Email"
                :rules="[
                  {
                    required: true,
                    message: 'Please input email address',
                    trigger: 'blur',
                  },
                  {
                    type: 'email',
                    message: 'Please input correct email address',
                    trigger: ['blur', 'change'],
                  },
                ]"
              >
                <el-input
                  placeholder="Email"
                  type="email"
                  v-model="formdata.email"
                ></el-input>
              </el-form-item>

              <!-- <el-form-item
    label="Telephone"
    prop="telephone"
    :rules="[
      { required: true, message: 'telephone no is required'},
      { type: 'number', message: 'telephone no must be a number'}
    ]"
  >
    <el-input v-model.number="formdata.telephone" auto-complete="off"></el-input>
  </el-form-item> -->

              <el-form-item label="Password" prop="pass">
                <el-input
                  placeholder="Password"
                  type="password"
                  v-model="formdata.pass"
                  auto-complete="off"
                ></el-input>
              </el-form-item>
              <el-form-item label="Confirm Password" prop="checkPass">
                <el-input
                  placeholder="Confirm Password"
                  type="password"
                  v-model="formdata.checkPass"
                  auto-complete="off"
                ></el-input>
              </el-form-item>

              <el-form-item class="pb-5 pt-2" style="margin-bottom: 0px">
                <el-button type="primary" @click="submitForm('formdata')"
                  >Sign up</el-button
                >
                <el-button @click="resetForm('formdata')">Reset</el-button>
              </el-form-item>
            </el-form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import db from "../../config/FirebaseInit";
import firebase from "firebase/app";
//import dataUrl from '../../data/dataUrl'
export default {
  name: "usersignup",
  data() {
    var validatePass = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("Please input the password"));
      } else {
        if (this.formdata.checkPass !== "") {
          this.$refs.formdata.validateField("checkPass");
        }
        callback();
      }
    };
    var validatePass2 = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("Please input the password again"));
      } else if (value !== this.formdata.pass) {
        callback(new Error("Two inputs don't match!"));
      } else {
        callback();
      }
    };
    return {
      checked: false,
      prvroute: "",
      loading: false,
      fetch: true,
      dataUrl: "",
      formdata: {
        name: "",
        email: "",
        telephone: "",
        pass: "",
        checkPass: "",
        telephone: "",
      },
      rules2: {
        pass: [{ validator: validatePass, trigger: "blur" }],
        checkPass: [{ validator: validatePass2, trigger: "blur" }],
      },
      labelPosition: "top",
    };
  },
  methods: {
    submit(checked) {
      if (checked) {
        //console.log('checked')
      }
      if (!checked) {
        //console.log('not checked')
      }
    },
    submitForm(fdata) {
      this.$refs[fdata].validate((valid) => {
        if (valid) {
          this.fetch = false;
          this.loading = true;
          //console.log(this.prvroute)
          firebase
            .auth()
            .createUserWithEmailAndPassword(
              this.formdata.email,
              this.formdata.pass
            )
            .then((user) => {
              // below code is to create admin & editor

              // user.user
              //   .updateProfile({
              //     displayName: "super admin",
              //   })
              //   .then(() => {
              //     // Update successful.
              //     //console.log(user)
              //   })
              //   .catch((error) => {
              //     alert(error);
              //     //console.log(error)
              //   });

              //console.log(user)
              db.collection("users")
                .doc(firebase.auth().currentUser.uid)
                .set({
                  name: this.formdata.name,
                  email: this.formdata.email,
                  pswd: this.formdata.pass,
                  telephone: this.formdata.telephone,
                  uid: firebase.auth().currentUser.uid,
                  refCode: `eshops${Math.floor(Math.random() * 1000001)}`,
                  role: "visitor",
                  favshops: [],
                  favpages: [],
                })
                .then((docRef) => {
                  // var id = docRef.id
                  ////console.log(id)
                  // alert(`Added ${user.email}` )
                  this.fetch = false;
                  this.loading = true;
                  //console.log('prv',this.prvroute)
                  //console.log('load', this.loading)
                  //console.log('fetch', this.fetch)

                  this.fetch = false;
                  this.loading = true;
                  //console.log('load', this.loading)
                  //console.log('fetch', this.fetch)
                })
                .catch((error) => alert(error));
              firebase
                .auth()
                .currentUser.sendEmailVerification()
                .then(() => {
                  // this.$router.push(this.prvroute);
                  this.$router.push("/myaccount");
                  //  if(this.prvroute == '/'){
                  //   this.$router.push('/myaccount')
                  //  // alert(`signin user ${user.email}`)
                  //   }else{
                  //      this.$router.push(this.prvroute)
                  //  // alert(`signin user ${user.email}`)
                  //   }
                })
                .catch((error) => alert(error));
            })
            .catch((error) => alert(error));
        } else {
          alert("error submit!!");
          return false;
        }
      });
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
  },
  created() {
    this.prvroute = true;
    //this.dataUrl = dataUrl
  },
  beforeRouteEnter(to, from, next) {
    setTimeout(() => {
      next((vm) => {
        vm.prvroute = from.fullPath;
      });
    }, 200);
  },
  //   beforeRouteEnter (to, from, next) {
  //     // this.prvroute = from
  //     //console.log(from.fullPath)
  //     if(firebase.auth().currentUser){
  //     if(firebase.auth().currentUser.displayName != 'shop owner'){
  //        setTimeout(() => {
  //       next(vm => {
  //        return vm.$router.push(from.fullPath)
  //       })
  //     },100)
  //     }
  //     }

  //    setTimeout(() => {
  //       next(vm => {
  //         vm.prvroute = from.fullPath
  //       })
  //     },200)

  // },
};
</script>

<style scoped>
@import url("~@/assets/main/css/loading.css");
::placeholder {
  color: red;
  opacity: 1; /* Firefox */
}

:-ms-input-placeholder {
  /* Internet Explorer 10-11 */
  color: red;
}

::-ms-input-placeholder {
  /* Microsoft Edge */
  color: red;
}
</style>



// WEBPACK FOOTER //
// src/components/user/UserSignup.vue